import React from "react";
import AboutSection from "../../About/About";
import { Container } from "react-bootstrap";
import ScrollAnimation from "react-animate-on-scroll";
import animationData from "./../../Home/Hero-Animation.json";
import Lottie from "react-lottie";
import './Home.css';

const Home = () => {

    const defaultOptions = {
			loop: true,
			autoplay: true,
			animationData: animationData,
		};

    return (
			<div className="main-home">
				<ScrollAnimation animateIn="wobble" initiallyVisible={true}>
					<h2 className="section-header">Welcome to LruW</h2>
				</ScrollAnimation>
				<Container>
					<div className="main-home-text">
						<div className="main-home-image">
							{/* <img src={aboutImage} alt="About Us" /> */}
							<Lottie options={defaultOptions} />
						</div>
						<div>
							<p>
								Welcome to Learn Your Way, your gateway to personalized IT
								training and skill development. At Learn Your Way, we understand
								that the ever-evolving world of technology requires flexible and
								tailored learning experiences to ensure your success. Our
								innovative AI-based training system is designed to empower
								individuals and organizations to harness the full potential of
								their IT knowledge.
							</p>
							<p>
								At Learn Your Way, we believe that everyone should have the
								opportunity to excel in the IT field. With our AI-based training
								system, you can embark on a learning journey that is tailored to
								your abilities and ambitions. Unlock your full potential and
								stay at the forefront of the ever-changing IT landscape with
								Learn Your Way. Join us today and start learning on your terms.
							</p>
						</div>
					</div>
				</Container>
			</div>
		);
}

export default Home;